'use strict';

module.exports = require('string.prototype.trimright');



//////////////////
// WEBPACK FOOTER
// ./node_modules/es7-shim/String.prototype.trimRight.js
// module id = 815
// module chunks = 0